import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { DRAWER_KEY, FIREBASE_EVENTS } from 'app-constants'
import { useFirebaseEvent } from 'hooks'
import { STATICS } from 'statics'
import { Button } from 'components/button'
import { setDrawer } from 'slices/drawer'
import './style.scss'

export function StoreSubscriptionError() {
  const dispatch = useDispatch()
  const { sendEvent } = useFirebaseEvent()

  useEffect(() => {
    sendEvent(FIREBASE_EVENTS.SOFTBUNDLE_PURCHASE_ERROR)
  }, [sendEvent])

  function handleCloseButtonClick() {
    dispatch(setDrawer(DRAWER_KEY.NONE))
  }
  return (
    <div className='store-subscription-error-modal'>
      <STATICS.INFO_TRIANGLE_FILLED className='icon' />
      <div className='info-container'>
        <h3 className='title'>Assinatura não concluída.</h3>
        <p className='description'>
          Estamos tendo dificuldades para concluir a assinatura do produto. Tente novamente em
          breve.
        </p>
      </div>
      <Button className='button' onClick={handleCloseButtonClick}>
        Ok, entendi!
      </Button>
    </div>
  )
}
